<div class="container mt-3">
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <h4 class="dark">
                        TAX INVOICE #{{invoiceData.invoice_no}}
                    </h4>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th width="50%">Date Issued</th>
                                <!-- <th>Due Date</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{invoiceData.invoice_date | date: 'MM-dd-YYYY' }} </td>
                                <!-- <td>{{invoiceData.due_date | date: 'MM-dd-YYYY' }}</td> -->

                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th width="50%">To:</th>
                                <th>From:</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="dark">{{invoiceData.plan_data.to.name}}</td>
                                <td class="dark">{{invoiceData.plan_data.from.name}}</td>
                            </tr>
                            <tr>
                                <td>{{invoiceData.plan_data.to.address1}}</td>
                                <td>{{invoiceData.plan_data.from.address1}}</td>
                            </tr>
                            <tr>
                                <td>{{invoiceData.plan_data.to.address2}}</td>
                                <td>{{invoiceData.plan_data.from.address2}}</td>
                            </tr>
                            <tr>
                                <td>{{invoiceData.plan_data.to.address3}}</td>
                                <td>{{invoiceData.plan_data.from.address3}}</td>
                            </tr>
                            <tr>
                                <td>{{invoiceData.plan_data.to.email}}</td>
                                <td>{{invoiceData.plan_data.from.email}}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th width="50%">Details</th>
                                <th>Quantity</th>
                                <th>Rate</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{invoiceData.plan_data.plan_name}}<br>
                                    from: {{invoiceData.invoice_date | date: 'MM-dd-YYYY' }}<br>
                                    until: {{invoiceData.due_date | date: 'MM-dd-YYYY' }}</td>
                                <td>1</td>
                                <td>AED {{invoiceData.plan_data.price}}</td>
                                <td>AED {{invoiceData.plan_data.price}}</td>
                            </tr>
                           
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td>Total</td>
                                <td>AED {{invoiceData.plan_data.price}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>




  